import _ from 'lodash';

function ensure(m) {
    return m.default ? m.default : m;
}

export default (Vue, projectName, account, delay = 1000) => {
    if (process.env.NODE_ENV !== 'production') {
        console.info('%c开发环境禁用第三方工具', 'color: red');
        return;
    }
    setTimeout(() => {
        import('../services/third-party').then(ensure).then(loadThirdParty => {
            loadThirdParty(account.thirdParty, projectName);
        });

        import('../services/sentry').then(ensure).then(sentryApp => {
            sentryApp(Vue, projectName, account.thirdParty?.sentry || {});
        });

        if (_.isObject(window.newrelic)) {
            window.newrelic.addPageAction('init', {
                uid: _.get(account, '_info.account_id', ''),
                cid: _.get(account, '_info.company_id', ''),
            });
        }
    }, delay);
};
